import React from 'react';
import ProcessUtils from 'utils/ProcessUtils';
import ProcessWizardPage from 'components/page/process/wizard/ProcessWizardPage';
import DataExplorerPage from 'components/core/data_explorer/DataExplorerPage';
import InputQCForm from 'components/core/forms/InputQCForm';
import AdvancedTransformationQuestion from 'components/core/forms/AdvancedTransformationQuestion';


export default class InputQCPage extends ProcessWizardPage {
    static defaultProps = {
        title: 'Interpreting the Quality of Input Data',
        description: 'Control how the process will identify missing/bad values in the input data.'
    };

    renderFormWithProcess() {
        return (
            <DataExplorerPage
                process = {this.props.process} 
                siteFacilities = {this.props.siteFacilities}
                exploredDatastreams = {this.props.exploredDatastreams}
            >
                <AdvancedTransformationQuestion
                    process={this.props.process}
                    hasWritePermissions={this.props.hasWritePermissions}
                    type="inputQC"
                />
                {ProcessUtils.shouldShowWizardInputQC(this.props.process, ['missing_value', 'qc_mask', 'qc_bad']) &&
                    <InputQCForm
                        process={this.props.process}
                        processErrors={this.props.processErrors}
                        hasWritePermissions={this.props.hasWritePermissions}
                        exploredDatastreams={this.props.exploredDatastreams}
                        className={this.overflowContainer}
                        border
                    />
                }
            </DataExplorerPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/page/process/wizard/InputQCPage.js